// extracted by mini-css-extract-plugin
export default {"container":"InvestigationStatusHeader_container__eQOYb","label":"InvestigationStatusHeader_label__1LdcO","dropdown":"InvestigationStatusHeader_dropdown__711il"};